import React, { useEffect, useState } from 'react';
import bgImage from './assets/bg.png';
import './App.css';
import { WalletProvider } from './context/WalletContext';
import WalletButton from './components/wallet/WalletButton';
import ValidatorKPIs from './components/validator/ValidatorKPIs';
import FavIcon from './components/common/FavIcon';

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);

  // Handle scroll events for parallax effect
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <WalletProvider>
      <FavIcon /> {/* Add the FavIcon component here */}
      
      <div className="App">
        <div 
          className="parallax-background"
          style={{ 
            backgroundImage: `url(${bgImage})`,
            transform: `scale(1.00) translateY(${Math.min(scrollPosition * 0.02, 40)}px)` 
          }}
        />
        <div className="content-wrapper">
          <div className="wallet-header">
            <WalletButton />
          </div>
          <header className="App-header">
            <h1 className="validator-title">Iceland's first Taraxa validator!</h1>
            <ValidatorKPIs />
            <div className="eco-footer">
              <span className="eco-text">
                Running on pure volcanic power!
              </span>
            </div>
          </header>
        </div>
      </div>
    </WalletProvider>
  );
}

export default App;